<div
  infiniteScroll
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="150"
  (scrolled)="onScroll()"
  [scrollWindow]="true">
  <app-hero-section></app-hero-section>
  <app-featured-ads-section id="featured-ads-anchor"></app-featured-ads-section>
</div>
